export default {
    primary: '#5150FE',
    secondary: '#273444',
    primaryText: '#e6dddd',
    secondaryText: '#948f8f',
    background: '#1E2E3D',
    label: '#696868',
    border: '#2e2d2d',
    shadow: '#000'
}